// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"c04a2bf5","977":"b19fe954"}[chunkId] + ".chunk.js";
};